import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

const PREFIX = 'ECCommonErrorBlock';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(2, 2),
    margin: theme.spacing(2, 2),
    textAlign: 'center',
    backgroundColor: theme.palette.error.light,
    '& p': {
      color: 'white',
    },
  },
}));

export const ECCommonErrorBlock = props => {
  const { form } = props;

  if (!form.formState.errors) return null;

  const errorKeys = Object.keys(form.formState.errors);
  const fieldKeys = Object.keys(form.getValues());
  const alienKeys = errorKeys.filter(e => e === '_' || fieldKeys.indexOf(e) === -1);

  if (alienKeys.length === 0) return null;
  return (
    <StyledPaper className={classes.root}>
      {alienKeys.map((k, i) => (
        <Typography component='p' key={i}>
          {!!k && k !== '_' && <>{k}:</>}
          {form.formState.errors[k].message}
        </Typography>
      ))}
    </StyledPaper>
  );
};

ECCommonErrorBlock.propTypes = {
  className: PropTypes.string,
  form: PropTypes.object,
};
